var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 7.38527V7.99861C14.6645 9.43622 14.199 10.8351 13.3383 11.9865C12.4775 13.1379 11.2676 13.9803 9.88894 14.3879C8.51032 14.7955 7.03687 14.7465 5.68835 14.2483C4.33982 13.7501 3.18847 12.8293 2.406 11.6233C1.62354 10.4173 1.25189 8.99065 1.34648 7.55615C1.44107 6.12165 1.99684 4.75616 2.93088 3.66332C3.86493 2.57049 5.12722 1.80886 6.52949 1.49204C7.93176 1.17521 9.39888 1.32017 10.712 1.90527",
    stroke: "#59D67C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66406L8 9.3374L6 7.3374",
    stroke: "#59D67C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e3b8c2bf32c9647c3f6e519df362ff8c.svg";
export { ForwardRef as ReactComponent };